<template>
  <div
    :id="{ 'mini-browser': showTiHeader }"
    class="relative mx-auto"
    :class="{
      'mini-browser': showTiHeader,
      'bg-gray-300 h-full': !showTiHeader,
    }"
  >
    <div v-if="showTiHeader" class="mini-browser-header flex justify-between">
      <div>{{ miniBrowserHeader.productName }}</div>
      <div class="btn-close cursor-pointer close close_event" id="btnClsMini">
        <svg width="24" height="24" class="w-6 h-6 fill-current text-gray-700" viewBox="0 0 24 24">
          <path :d="mdiClose" />
        </svg>
      </div>
    </div>

    <div class="layout mx-auto h-full flex flex-col" :class="{ 'mini-browser-content': showTiHeader }">
      <div class="intro-container--mobile" :class="{ 'active': showIntro }">
        <div class="mask" @click="showIntro = !showIntro"></div>
        <div class="intro-header bg-gray-200 flex justify-between items-center p-5">
          <div class="flex items-center">
            <img
              src="@/assets/images/img_tball_web.png"
              width="32"
              height="32"
              alt="Tball"
            />
            <div class="text-gray-700 px-2">{{ planSubtitle }}</div>
          </div>
          <img
            src="@/assets/images/arrow-down-chevron.svg"
            width="24"
            height="24"
            alt="Tball"
            class="arrow-down-chevron cursor-pointer"
            @click="showIntro = !showIntro"
          >
        </div>
        <div class="intro-detail bg-gray-200 px-8">
          <div class="intro-title text-gray-800 mb-8">
            {{ planTitle }}
          </div>
          <ul class="intro-features text-sm text-gray-700 pb-8">
            <li v-for="(feature, i) in planFeatures" :key="i" class="flex items-center mb-3">{{ feature }}</li>
          </ul>
        </div>
      </div>

      <div class="bg-gray-300 w-full flex flex-auto">
        <div class="intro-container flex justify-end">
          <div class="intro">
            <div class="text-gray-700 mb-3">{{ planSubtitle }}</div>
            <div class="intro-title text-gray-800 mb-10">
              {{ planTitle }}
            </div>
            <ul class="intro-features text-gray-700">
              <li v-for="(feature, i) in planFeatures" :key="i" class="flex items-center mb-2">
                {{ feature }}
              </li>
            </ul>
          </div>
        </div>
        <div class="sso-container">
          <MobileHeader />

          <main class="bg-gray-300 flex-shrink-0 w-full my-0 mx-auto">
            <div class="flex justify-center px-4 pb-4">
              <div class="form-card bg-white border border-gray-100 w-full">
                <router-view></router-view>
              </div>
            </div>
          </main>
        </div>
      </div>

      <MobileFooter />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mdiClose } from '@mdi/js';
import MobileHeader from './../MobileHeader';
import MobileFooter from './../MobileFooter';

export default {
  name: 'PlanInfoLayout',
  props: {
    planTitle: {
      type: String,
      required: true,
    },
    planSubtitle: {
      type: String,
      required: true,
    },
    planFeatures: {
      type: Array,
      required: true,
    },
  },
  components: {
    MobileHeader,
    MobileFooter,
  },
  computed: {
    ...mapState(['userLang', 'miniBrowserHeader']),
  },
  data() {
    return {
      mdiClose,
      showTiHeader: false,
      showIntro: false,
    };
  },
  mounted() {
    this.showTiHeader = navigator.userAgent.includes('uiWinMgr');

    if (this.showTiHeader) window.resizeTo(836, 626);
  },
};
</script>

<style lang="sass" scoped>
.layout
  max-width: 1280px

.form-card
  max-width: 480px
  padding: 40px
  border-radius: 16px

  @media (max-width: 720px)
    padding: 24px

/* mini browser header */
.mini-browser
  width: 800px
  height: 600px
  border-radius: 8px
  box-shadow: 0 2px 12px rgba(0,0,0,.25)
  overflow: hidden

.mini-browser-header
  background: rgba(250, 250, 250, 0.85)
  box-shadow: inset 0px -1px 0px #C9C9C9
  padding: 9px 8px 10px 16px
  font-size: 14px
  line-height: 19px
  color: #333

.mini-browser-content
  height: 557px
  overflow: scroll
  overflow-x: hidden

.btn-close
  padding-left: 8px
  border-left: 1px solid rgba(0, 0, 0, 0.15)

.intro-container
  width: 36%
  padding: 96px 24px 0 24px

  @media (max-width: 959px)
    display: none

  .intro
    width: 356px

.intro-title
  font-size: 32px
  line-height: 37.5px
  font-weight: 600

.intro-features
  li::before
    content: ''
    display: inline-block
    width: 11.04px
    height: 8.48px
    background-size: contain
    background-repeat: no-repeat
    background-image: url('~@/assets/images/icon_plan_check.svg')
    margin: 0px 8px 0 0
    vertical-align: middle

.intro-container--mobile
  display: none

  @media (max-width: 767px)
    z-index: 1
    display: block
    position: fixed
    border-radius: 0 0 8px 8px
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08)
    overflow: hidden
    width: 100%

  .mask
    z-index: -1
    position: fixed
    width: 100vw
    height: 100vh
    opacity: 0
    pointer-events: none
    background-color: rgba(0, 0, 0, 0.5)
    transition: opacity 0.3s

  .intro-header
    height: 90px
    
  .arrow-down-chevron
    transition: all 0.3s

  .intro-detail
    max-height: 0
    transition: all 0.3s

.intro-container--mobile.active
  .mask
    opacity: 1
    pointer-events: auto

  .arrow-down-chevron
    transform: rotate(180deg)

  .intro-detail
    max-height: 100vh


.sso-container
  width: 64%

  @media (max-width: 959px)
    width: 100%

  @media (max-width: 767px)
    margin-top: 90px
</style>
